import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

const lightbox = GLightbox({
  selector: ".glightbox",
  touchNavigation: true,
  zoomable: true,
});

const buttons = document.querySelectorAll('.services-btn');

buttons.forEach(button => {
    button.addEventListener('click', () => {
        const targetClass = button.getAttribute('data-target');
        const b = GLightbox({ selector: `.${targetClass}` });
        b.openAt(0);
    });
});
